var _sodipodiNamedview, _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg52(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1001.9999 1002.0056",
    height: 1002.0056,
    width: 1001.9999,
    xmlSpace: "preserve",
    id: "svg2",
    inkscapeVersion: "0.91 r13725",
    sodipodiDocname: "new.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    "inkscapeWindow-width": 1600,
    "inkscapeWindow-height": 1135,
    id: "namedview52",
    showgrid: "false",
    "fit-margin-left": 1,
    "fit-margin-bottom": 1,
    "fit-margin-top": 1,
    "fit-margin-right": 1,
    inkscapeZoom: 0.25,
    inkscapeCx: 13.10864,
    inkscapeCy: -168.41666,
    "inkscapeWindow-x": 1600,
    "inkscapeWindow-y": 0,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg2"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3513"
  }, /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccc",
    "inkscapeConnector-curvature": 0,
    d: "m 1,501.00203 c 494.15716,341.59309 495.07083,342.23968 1000,0 L 500.99929,0.9999542 1,501.00203",
    style: {
      fill: "#ef2e33",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "ccc",
    "inkscapeConnector-curvature": 0,
    d: "M 1,501.00203 500.99929,1001.0055 1001,501.00203",
    style: {
      fill: "#f5f014",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "M 502.35999,73.585375 88.865667,487.08276 C 157.96123,417.98831 488.97328,86.974865 502.35999,73.585375",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "m 391.22723,489.99417 -1.99732,1.99733 c 0.6307,-0.63019 1.295,-1.29422 1.99732,-1.99733",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "M 498.22073,60.03974 58.745868,499.51725 502.643,55.617472 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "M 88.742563,511.82906 502.36974,925.45638 C 489.089,912.17257 157.58621,580.67256 88.742563,511.82906",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccc",
    "inkscapeConnector-curvature": 0,
    d: "m 502.643,73.302361 426.21489,426.214889 17.68628,0 L 502.643,55.617472 58.745868,499.51725 l 17.685726,0",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccc",
    "inkscapeConnector-curvature": 0,
    d: "m 946.54417,499.51725 -17.68628,0 C 782.17578,646.19814 625.76523,802.63428 502.643,925.7281 354.66424,777.65467 203.95169,627.11742 76.431594,499.51725 l -17.685726,0 C 206.71098,647.48389 354.67717,795.44944 502.643,943.41536",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "m 448.3559,805.96006 c -3.61366,0 -6.36573,-0.99124 -8.24923,-2.97095 -1.88909,-1.98249 -3.16614,-4.79729 -3.83254,-8.4472 l -16.71874,0 c 0.58555,7.98434 3.47982,14.14931 8.68281,18.4935 5.20439,4.3442 11.85313,6.51769 19.95179,6.51769 10.05606,0 17.60682,-3.08945 22.65227,-9.26418 5.04685,-6.17472 7.57028,-13.19012 7.57028,-21.04759 0,-9.02857 -2.61962,-15.90734 -7.85329,-20.63772 -5.23367,-4.72759 -11.36935,-7.09487 -18.40009,-7.09487 -3.47982,0 -6.42567,0.45032 -8.84593,1.34955 -1.44853,0.5493 -3.45891,1.66044 -6.0367,3.33761 l 3.06296,-18.68868 34.94595,0 0,-14.13397 -46.95662,0 -6.05622,47.0319 15.00393,0.67757 c 1.3342,-2.53737 3.31949,-4.27728 5.95165,-5.21694 1.49454,-0.50608 3.26233,-0.764 5.30756,-0.764 4.3205,0 7.50475,1.49872 9.5458,4.48919 2.04523,2.99186 3.06715,6.6571 3.06715,10.9999 0,4.41948 -1.09302,8.08472 -3.27349,10.99712 -2.18046,2.91797 -5.35356,4.37207 -9.5193,4.37207",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "m 508.53889,799.84111 -17.80897,0 0,17.53571 17.80897,0 0,-17.53571",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    "inkscapeConnector-curvature": 0,
    d: "m 541.32111,782.61071 c -8.88496,6.36294 -14.52433,12.37873 -16.9181,18.04877 -2.4816,5.04406 -3.79908,10.6179 -3.95662,16.71734 l 58.31483,0 0,-14.67909 -37.12503,0 c 1.0512,-1.76779 2.35334,-3.31948 3.89389,-4.65369 1.54193,-1.33561 4.40832,-3.49376 8.59916,-6.48005 l 6.69893,-4.77081 c 5.63658,-4.00541 9.69079,-7.6358 12.15705,-10.88976 3.76144,-4.89768 5.63937,-10.50777 5.63937,-16.81912 0,-8.2311 -2.66284,-14.84638 -7.98852,-19.84583 -5.32847,-4.99666 -12.49584,-7.49778 -21.50628,-7.49778 -11.39863,0 -19.32999,4.24939 -23.79548,12.74678 -2.35055,4.46688 -3.66245,10.32095 -3.93571,17.56778 l 16.31165,0 c 0.19518,-4.78614 0.81976,-8.27572 1.87514,-10.47291 1.8361,-3.80187 5.29083,-5.70489 10.37253,-5.70489 3.70567,0 6.56091,1.19897 8.55316,3.59135 1.98946,2.39377 2.98628,5.39399 2.98628,9.00486 0,4.43342 -1.73991,8.51552 -5.21275,12.24349 -2.26551,2.39238 -7.2552,6.35876 -14.9635,11.89356",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccsccccccccccccccccccccccsccccccc",
    id: "path3532",
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "m 496.06065,136.77262 c -20.44153,39.04219 4.46543,61.08088 -22.99198,118.59305 -14.56787,-11.6394 -6.12237,-55.13765 -35.05471,-55.86663 4.45259,13.35767 1.11999,18.5462 0.37792,23.36981 -2.87804,18.70691 -9.55674,35.42471 3.4299,60.2848 -19.9494,-9.69248 -20.28053,-27.47664 -37.14753,-38.62994 3.33939,18.92336 -4.70242,57.29548 17.70171,94.06055 -19.964,-1.96363 -26.58493,-9.63816 -48.19296,-30.34586 22.551,116.82175 39.32815,120.10347 122.02295,126.73178 -6.23065,-0.73041 -47.89699,-7.38456 -62.98798,-55.40154 -0.85657,-11.88957 -1.32685,10.44867 38.74616,11.19076 -25.37352,-40.18472 -18.46108,-32.57792 -15.49262,-55.95384 10.50371,15.99793 1.30164,17.39693 30.98534,29.27041 -9.41145,-29.90123 14.52508,-50.3613 9.33043,-84.49755 6.55899,14.99194 29.88936,12.63085 28.77626,84.61381 19.31755,-21.55164 21.62198,-6.6348 30.89819,-30.7528 0.53725,13.42707 6.43044,30.14546 -19.82365,57.66878 6.67879,1.85523 17.8617,3.2919 36.04299,-8.95262 -17.70273,20.06305 -1.70328,20.53618 -46.47806,53.36688 56.39904,0.74208 93.44136,-34.7609 92.11313,-112.77968 -1.48423,6.67885 -3.14659,20.01498 -33.57234,24.09649 19.0585,-18.93798 28.99064,-56.64329 13.77772,-87.81118 -5.35622,4.98159 -13.68119,28.14334 -33.71763,34.82218 10.163,-16.67378 7.87718,-38.25207 7.87718,-38.25207 0,0 2.59276,-29.14365 -14.62071,-51.65193 -4.82362,35.24939 -4.42068,52.9751 -26.68344,58.54078 3.58272,-20.80393 4.24256,-30.49192 -6.88881,-54.23887 -11.62621,-24.80247 -25.08806,-49.2128 -28.42746,-71.47557 z m -93.13042,318.34095 c 0,6.81135 0,13.6227 0,20.43405 l 198.52709,0 c -0.0191,-6.79197 -0.0384,-13.58394 -0.0576,-20.37591 -66.15632,-0.0194 -132.31263,-0.0387 -198.46895,-0.058 z",
    "inkscapeConnector-curvature": 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg52);
export default __webpack_public_path__ + "static/media/5.2.a50605eda665baa68da15624d57b25a2.svg";
export { ForwardRef as ReactComponent };